export default {
  text: {
    order_cancelled: 'Pedido cancelado - Conductor no disponible',
    wolt_support: '¿Preguntas? Llama a Wolt directamente <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENTE:</strong> Acepta o rechaza este pedido inmediatamente',
  },
  labels: {
    dummy_order: 'Pedido de prueba',
    items_one: '{{count}} artículo',
    items_other: '{{count}} artículos',
    needs_acceptance: 'Requiere aceptación',
    driver_pending: 'Esperando conductor',
    today: 'Hoy',
    driver_assigned: 'Conductor asignado',
    complete: 'Completado',
  },
  buttons: {
    complete_order: 'Marcar como completado',
    looking_for_driver: 'Buscando conductor...',
    click_to_remove: 'Clic para eliminar',
  },
};
